import { DashboardLayout, LayoutSlot } from '../types/Layout';

const slot = (id: string, formFactor: LayoutSlot['formFactor'], size: LayoutSlot['size'], x: number, y: number, w: number, h: number): LayoutSlot => ({
  id,
  formFactor,
  size,
  x,
  y,
  w,
  h,
});

export const SUGGESTED_LAYOUTS: DashboardLayout[] = [
  {
    id: 'suggested-kpi-heavy',
    name: 'KPIs em destaque',
    isSuggested: true,
    slots: [
      // 6 tiles cobrindo 12 cols (w=2 cada).
      slot('kpi-1', 'tile', 'small', 0, 0, 2, 2),
      slot('kpi-2', 'tile', 'small', 2, 0, 2, 2),
      slot('kpi-3', 'tile', 'small', 4, 0, 2, 2),
      slot('kpi-4', 'tile', 'small', 6, 0, 2, 2),
      slot('kpi-5', 'tile', 'small', 8, 0, 2, 2),
      slot('kpi-6', 'tile', 'small', 10, 0, 2, 2),
      slot('graph-1', 'graph', 'medium', 0, 2, 6, 5),
      slot('graph-2', 'graph', 'medium', 6, 2, 6, 5),
      slot('graph-3', 'graph', 'full', 0, 7, 12, 5),
    ],
    assignments: [],
  },
  {
    id: 'suggested-analytics',
    name: 'Análise profunda',
    isSuggested: true,
    slots: [
      slot('hero', 'graph', 'full', 0, 0, 12, 6),
      slot('graph-1', 'graph', 'medium', 0, 6, 6, 5),
      slot('graph-2', 'graph', 'medium', 6, 6, 6, 5),
      slot('kpi-1', 'tile', 'small', 0, 11, 2, 2),
      slot('kpi-2', 'tile', 'small', 2, 11, 2, 2),
      slot('kpi-3', 'tile', 'small', 4, 11, 2, 2),
      slot('kpi-4', 'tile', 'small', 6, 11, 2, 2),
      slot('kpi-5', 'tile', 'small', 8, 11, 2, 2),
      slot('kpi-6', 'tile', 'small', 10, 11, 2, 2),
    ],
    assignments: [],
  },
  {
    id: 'suggested-mixed',
    name: 'Misto',
    isSuggested: true,
    slots: [
      slot('kpi-1', 'tile', 'small', 0, 0, 2, 2),
      slot('kpi-2', 'tile', 'small', 2, 0, 2, 2),
      slot('kpi-3', 'tile', 'small', 4, 0, 2, 2),
      slot('graph-1', 'graph', 'medium', 6, 0, 6, 4),
      slot('graph-2', 'graph', 'full', 0, 4, 12, 5),
      slot('graph-3', 'graph', 'medium', 0, 9, 6, 5),
      slot('graph-4', 'graph', 'medium', 6, 9, 6, 5),
    ],
    assignments: [],
  },
];

export function isSuggestedLayoutId(id: string | undefined): boolean {
  if (!id) return false;
  return id.startsWith('suggested-');
}

export function getSuggestedLayout(id: string): DashboardLayout | undefined {
  return SUGGESTED_LAYOUTS.find((l) => l.id === id);
}
